import { Routes, Route, Navigate } from "react-router-dom";
import AuthenticationEmailVerification from "../Pages/AuthenticationEmailVerification";
import AuthenticationLogin from "../Pages/AuthenticationLogin";
import AuthenticationResetPassword from "../Pages/AuthenticationResetPassword";

function AuthRoutes() {

  return (
    <Routes>
      <Route path="/login" element={<AuthenticationLogin />} />
      <Route path="/reset_password" element={<AuthenticationResetPassword />} />
      <Route path="/email_verification" element={<AuthenticationEmailVerification />} />

      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
}

export default AuthRoutes;